@use "~theme/typography";
@use "~theme/breakpoints";

.container {
  background: var(--white);
  padding: 16px;
  width: 100%;

  @include breakpoints.desktop-large {
    padding: 0;
  }
}

.desktopOnly {
  display: none;

  @include breakpoints.desktop-large {
    display: block;
  }
}

.mobileOnly {
  display: inline;
  padding-left: 20px;
  padding-right: 20px;

  @include breakpoints.desktop {
    padding-left: 80px;
    padding-right: 80px;
  }

  @include breakpoints.desktop-large {
    display: none;
  }
}

.row {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.textRow {
  margin-bottom: 16px;
}

.text {
  @include typography.heading5;
  color: var(--blue-01);
}

@mixin bar($bar-color) {
  width: 100%;
  border-bottom: 4px solid $bar-color;
}

.incompleteBar {
  @include bar(var(--blue-01-at-30));
}

.completeBar {
  @include bar(var(--blue-01));
}
